<template>
  <section class="add-comment">
    <h3 class="add-comment__title">
      {{ spellTransactionType(transaction, user) }}
    </h3>
    <section class="image-and-form">
      <image-upload
        @loadStart="imageUrl = null"
        @loadImage="loadImage"
        @imageError="handleError"
        :value="imageUrl"
        size="43px"
      />
      <form @submit.prevent="submitTransaction" class="add-comment-form">
        <div class="input-group_comment">
          <app-textarea
            v-model="$v.comment.$model"
            @input="chooseError"
            :error="$v.comment.$error"
            :placeholder="$t('addCommentForm.placeholder')"
            :focus-on-mount="true"
          />
        </div>
      </form>
    </section>
    <span
        v-if="$v.$anyError"
        class="form__error-message">
        {{ $t('validateText.fillInTheFields') }}
    </span>
    <span
        v-if="imageError"
        class="form__error-message">
        {{ errorMessage }}
    </span>
    <div class="form-buttons">
      <button-app
        class="form-button form-button_cancel"
        @clicked="cancelSubmit"
        color-scheme="gray"
        type="button">
        {{ $t('CP.cancel') }}
      </button-app>
      <button-app
        class="form-button form-button_save"
        color-scheme="blue"
        @clicked="submitTransaction"
        type="button"
      >
        {{ $t('CP.create') }}
      </button-app>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { DELETE_FINAL_EVENT_SELECTED_CONTACTS } from '@/store/user/types';
import {
  ADD_TRANSACTION_REQUEST,
  // FETCH_EVENT_REQUEST,
  FETCH_EVENT_SUCCESS,
} from '@/store/events/types';
import ButtonApp from '../../components/Button/ButtonApp';
import ImageUpload from '../../components/ImageUpload/ImageUpload';
import AppTextarea from '../../components/AppTextarea/AppTextarea';

export default {
  name: 'AddCommentForm',
  components: {
    AppTextarea,
    ImageUpload,
    ButtonApp,
  },
  props: {
    operationType: {
      type: String,
      default: '',
    },
    spellTransactionType: {
      type: Function,
      default: () => '',
    },
  },
  validations: {
    comment: {
      required,
    },
  },
  data() {
    return {
      comment: '',
      imageUrl: '',
      errorMessage: '',
      imageError: false,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
      event: (state) => state.events.event,
      eventCurrency: (state) => state.events.eventCurrency,
      currencies: (state) => state.currency.currencies,
      transaction: (state) => state.operations.selectedOperation,
    }),
  },
  methods: {
    handleError(message) {
      this.errorMessage = message;
      this.imageError = !!message;
    },
    chooseError() {
      if (this.$v.$anyError) {
        this.errorMessage = this.$t('validateText.fillInTheFields');
      }
    },
    cancelSubmit() {
      this.$bvModal.hide('add-transaction');
      this.$store.commit(DELETE_FINAL_EVENT_SELECTED_CONTACTS);
    },
    async submitTransaction() {
      this.$v.$touch();
      if (this.$v.$anyError || this.imageError) {
        return;
      }
      const data = {
        details: this.comment,
        amount: 1,
        currency: this.currentCurrency,
        event_id: this.event.id,
        payee: this.user.phone,
        operation_type: 'comment',
        participants: [{ phone: this.user.phone, amount: 1 }],
      };
      let imageUrl = '';
      if (this.imageUrl) {
        // eslint-disable-next-line prefer-destructuring
        imageUrl = this.imageUrl.split('base64,')[1];
      }
      data.image_url = imageUrl || null;
      const transactionData = await this.$store.dispatch(ADD_TRANSACTION_REQUEST, data);
      if (transactionData && transactionData.event_data) {
        this.$store.commit(FETCH_EVENT_SUCCESS, transactionData.event_data);
      }
      // await this.$store.dispatch(FETCH_EVENT_REQUEST, {
      //   id: data.event_id,
      //   currency: data.currency,
      // });
      this.$bvModal.hide('add-transaction');
    },
    loadImage(file) {
      try {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async () => {
          const img = new Image();
          img.src = reader.result.toString();
          img.onload = () => {
            if (img.width < 70 || img.width > 10000
              || img.height < 70 || img.height > 10000 || file.size > 5242880) {
              this.errorMessage = 'image size should be between 70x70 and 10000x10000 px';
              // eslint-disable-next-line no-console
              console.log('image size should be between 70x70 and 10000x10000 px',
                'current size: ', img.width, img.height);
            }
          };
          await img.onload;
          this.imageUrl = reader.result.toString();
        };
        return null;
      } catch (e) {
        return e;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
body {
  height: 100%;
}
  .add-comment {
    color: var(--text-main-color);
    display: flex;
    flex-direction: column;
    flex: 1;
  }
  .add-comment__title {
    margin: 0 0 26px;
  }
  .image-and-form {
    display: flex;
    flex: 1 0 auto;
    flex-direction: column;
    align-items: center;
    padding: 4px;
  }
  .add-comment-form {
    flex: 1 0 auto;
    display: flex;
    flex-wrap: wrap;
  }
  .input-group_comment {
    flex: 1 0 50%;
    min-height: 75px;
    width: 90vw;
    min-width: 372px;
  }
  .form-buttons {
    display: flex;
    justify-content: center;
    position: absolute;
    bottom: 10svh;
    left: 16px;
    right: 16px;
  }
  .form__error-message {
    height: 40px;
    font-size: 1rem;
    color: var(--error-red);
    display: flex;
  }
  .form-button {
    flex: 1;
    height: 38px;
    margin: 0;
  }
  .form-button_cancel {
    margin: 0 8px 0 0;
  }

@media (min-width: $breakpoint-sm) {
  .add-comment {
    min-height: 0;
  }
  .image-and-form {
    flex-direction: row;
  }
  .input-group_comment {
    width: auto;
  }
  .form-buttons {
    justify-content: flex-end;
    position: relative;
    inset: 0;
    margin-top: 24px;
  }
}
</style>
